import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { ORDER_STATUS } from '../enums';

@Pipe({
  name: 'orderStatus'
})
export class OrderStatusPipe extends EnumConverter implements PipeTransform {
  enumeration = ORDER_STATUS;
}
